import { Grid } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import QCXSelectUsuarioAutoComplete from '../../../../../../components/usuario/QCXSelectUsuarioAutoComplete';
import QCXFinalDateTimePickerField from '../../../../../../shared-components/final-date-time-picker-field/QCXFinalDateTimePickerField';
import QCXFinalBondManager from '../../../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager.tsx';
import { formatDate } from '../../../../../../utils/general/general-utils';
import EtapaOcorrenciaAutoComplete from './EtapaOcorrenciaAutoComplete';

function EtapaOcorrenciasBondManager({
  name = 'ocorrencias',
  etapaId,
  isConsult,
  controlButtonsGridProps = undefined,
  isModelo = false,
}) {
  const form = useForm();
  const { t } = useTranslation();

  const ocorrenciaEtapaListProps = useMemo(
    () => ({
      name,
      columns: [
        {
          field: t('com.muralis.qcx.listaFollowUp.ocorrenciaComOminusculo'),
          headerName: t('com.muralis.qcx.listaFollowUp.ocorrencia'),
          headerAlign: 'left',
          align: 'left',
          flex: 140,
          valueGetter: ({ row }) => row?.description || '',
        },
        ...(!isModelo
          ? [
              {
                field: 'dataInicio',
                headerName: 'Data início',
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => (row?.dataInicio ? formatDate(row.dataInicio) : ''),
              },
              {
                field: 'dataFim',
                headerName: 'Data fim',
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => (row?.dataFim ? formatDate(row.dataFim) : ''),
              },
              {
                field: 'usuario',
                headerName: 'Usuário Responsável',
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => row?.usuarioResponsavel?.nome || '',
              },
            ]
          : []),
      ],
    }),
    [isModelo]
  );

  const ocorrenciaEtapaFormProps = useMemo(() => ({
    rootName: 'ignorableFields.ocorrencias.form',
    fields: [
      {
        name: 'ocorrencia',
        label: t('com.muralis.qcx.listaFollowUp.ocorrencia'),
        required: true,
      },
      {
        name: 'ocorrencia.dataInicio',
        label: 'Data início',
        required: false,
      },
      {
        name: 'ocorrencia.dataFim',
        label: 'Data fim',
        required: false,
      },
      {
        name: 'ocorrencia.usuarioResponsavel',
        label: 'Usuário Responsável',
        required: false,
      },
    ],
  }));

  const handleAdd = useCallback((currentVinculo, currentVinculosList, handleSuccessAddVinculo) => {
    const updatedVinculos = [...currentVinculosList, currentVinculo.ocorrencia];

    handleSuccessAddVinculo(updatedVinculos);
  }, []);

  const handleUpdate = useCallback((currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
    const newVinculo = currentVinculo.ocorrencia;

    const updatedVinculos = currentVinculos.map((v) => (v.id === newVinculo.id ? newVinculo : v));

    handleSuccessUpdateVinculo(updatedVinculos);
  }, []);

  const handleAlreadyExists = useCallback(
    (currentVinculo, currentVinculosList, isUpdate) =>
      isUpdate ? false : currentVinculosList.some((v) => v.id === currentVinculo.ocorrencia.id),
    []
  );

  return (
    <>
      <QCXFinalBondManager
        controlButtonsGridProps={controlButtonsGridProps}
        isParentConsult={isConsult}
        listProps={ocorrenciaEtapaListProps}
        formProps={ocorrenciaEtapaFormProps}
        handleAdd={handleAdd}
        handleAlreadyExists={handleAlreadyExists}
        handleUpdate={handleUpdate}
        appendRootName=".ocorrencia"
        dontCheckEqual
      >
        <Grid item style={{ paddingBottom: '1rem' }} xs={4}>
          <EtapaOcorrenciaAutoComplete
            etapaId={etapaId}
            disabled={isConsult}
            name="ignorableFields.ocorrencias.form.ocorrencia"
          />
        </Grid>

        {!isModelo ? (
          <>
            <Grid item xs={2}>
              <QCXFinalDateTimePickerField
                id="date-picker-data-inicio-ocorrencia-field"
                key="date-picker-data-inicio-ocorrencia-field"
                name="ignorableFields.ocorrencias.form.ocorrencia.dataInicio"
                label="Data início"
                disabled={isConsult}
              />
            </Grid>

            <Grid item xs={2}>
              <QCXFinalDateTimePickerField
                id="date-picker-data-fim-ocorrencia-field"
                key="date-picker-data-fim-ocorrencia-field"
                name="ignorableFields.ocorrencias.form.ocorrencia.dataFim"
                label="Data fim"
                disabled={isConsult}
              />
            </Grid>

            <Grid item xs={2}>
              <QCXSelectUsuarioAutoComplete
                key="text-field-processo-viewer-ocorrencia-usuario-responsavel"
                id="text-field-processo-viewer-ocorrencia-usuario-responsavel"
                name="ignorableFields.ocorrencias.form.ocorrencia.usuarioResponsavel"
                label="Usuário responsável"
                disabled={isConsult}
              />
            </Grid>
          </>
        ) : null}
      </QCXFinalBondManager>
    </>
  );
}

export default EtapaOcorrenciasBondManager;
